<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup lang="ts">
import { onMounted, watch } from 'vue';
import { useAuthStore } from './stores/auth';
import { useCustomizationStore } from './stores/customization';

const authStore = useAuthStore();
const customizationStore = useCustomizationStore();

// Load customization when user is authenticated
watch(
  () => authStore.isAuthenticated,
  async (isAuthenticated) => {
    if (isAuthenticated) {
      await customizationStore.loadCustomization();
    }
  },
  { immediate: true }
);

onMounted(() => {
  // Apply default colors immediately
  customizationStore.applyColors();
});
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
